import { TwoColumnBox } from "Components/TwoColumnBox";
import { Country } from "./Country";
import { Stage } from "./Stage";
import { useState } from "react";
import { Form } from "antd";
import { Identity } from "./Identity";

export const ProgramAndCountry = ({ form }) => {
  const [state, setState] = useState({
    country: form.getFieldValue("country"),
    stage: form.getFieldValue("stage"),
    identity: form.getFieldValue("identity"),
  });
  return (
    <TwoColumnBox
      leftElement={
        <>
          <Form.Item
            name="identity"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Identity
              identity={state.identity}
              setIdentity={(value) => {
                form.setFieldsValue({
                  identity: value,
                });
                setState((prev) => ({ ...prev, identity: value }));
              }}
            />
          </Form.Item>
          <Form.Item
            name="country"
            rules={[{ required: true, message: "Please select a country" }]}
          >
            <Country
              country={state.country}
              setCountry={(value) => {
                form.setFieldsValue({
                  country: value,
                });
                setState((prev) => ({ ...prev, country: value }));
              }}
            />
          </Form.Item>
        </>
      }
      rightElement={
        <Form.Item
          name="stage"
          rules={[{ required: true, message: "Please select a stage" }]}
        >
          <Stage
            stage={state.stage}
            setStage={(value) => {
              form.setFieldsValue({
                stage: value,
              });
              setState((prev) => ({ ...prev, stage: value }));
            }}
          />
        </Form.Item>
      }
    />
  );
};
